import { orderObjectBy } from 'Utils/filters';
import template from './monitoringActionsPanel.html';


export default {
  name: 'monitoringActionsPanel',
  template,
  controller: MonitoringActionsPanelController,
  bindings: {
    panelId: '<'
  }
};

/* @ngInject */
function MonitoringActionsPanelController(
  growl,
  MonitoringActionsPanelService,
  DashboardService,
  ModalService
) {

  /**
   * Private Variables
   */
  const vm = this;

  /**
   * Public Variables
   */
  vm.loadingSpinners = {};
  vm.editPanel = {
    needsToBeConfigured: false
  };
  vm.equipmentFilterText = {};
  vm.equipments = MonitoringActionsPanelService.equipmentModel;

  /**
   * Public Methods
   */
  vm.$onInit = init;
  vm.$onDestroy = destroyPanel;
  vm.powerCycleEquipment = powerCycleEquipment;
  vm.powerCycleEquipmentModal = powerCycleEquipmentModal;
  vm.clearFilter = clearFilter;


  function init() {
    vm.currentDashboard = DashboardService.getCurrentDashboard();
    vm.panel = vm.currentDashboard.panels[vm.panelId];
    if (vm.panel.equipment && vm.panel.equipment.length) {
      // panel is good to go
      vm.loadingSpinners.stopMonitoringActionsPanel = false;
      vm.editPanel.needsToBeConfigured = false;
      MonitoringActionsPanelService.getEquipmentFromIds(vm.panel.equipment)
        .finally(() => {
          vm.orderedEquipment = orderObjectBy(vm.equipments, 'name');
          vm.loadingSpinners.stopMonitoringActionsPanel = true;
        });

    } else {
      // panel needs to be configured
      vm.loadingSpinners.stopMonitoringActionsPanel = true;
      vm.editPanel.needsToBeConfigured = true;
    }

  }

  function destroyPanel() {
    deleteModel(vm.panel.equipment);
  }

  function powerCycleEquipment(equipmentId) {
    let growlMessage = growl.info('Sending request to power cycle…', {
      disableCloseButton: true
    });

    MonitoringActionsPanelService.powerCycleEquipment(vm.equipments[equipmentId].rcu)
      .then(() => {
        growlMessage.destroy();
        growlMessage = growl.success('The request to power cycle was successfully completed');
        close();
      })
      .catch((res) => {
        growlMessage.destroy();
        growlMessage = growl.error(res.error, {
          title: 'Request could not be completed:'
        });
      });
  }

  function powerCycleEquipmentModal(equipmentId) {
    return ModalService.confirmationModal({
      modalTitle: 'Confirm',
      selectionCriteria: `Are you sure you want to power cycle ${vm.equipments[equipmentId].name}?`,
      onConfirm: () => powerCycleEquipment(equipmentId)
    });
  }

  function clearFilter() {
    vm.equipmentFilterText = {};
  }

  function deleteModel() {
    MonitoringActionsPanelService.deleteModel();
  }

}
